const normalizeMimeType = (mimeType: string) =>
  mimeType.trim().toLowerCase().split(";", 1)[0];

const configuredMimeTypes = (acceptedFileTypes: string[]) =>
  acceptedFileTypes
    .flatMap((acceptedFileType) => acceptedFileType.split(","))
    .map(normalizeMimeType)
    .filter(Boolean);

export const useIsAcceptedFileType = (
  fileType: string,
  acceptedFileTypes: string[]
) => {
  const normalizedFileType = normalizeMimeType(fileType);

  if (!normalizedFileType) return false;

  return configuredMimeTypes(acceptedFileTypes).some((acceptedFileType) => {
    if (acceptedFileType === "*/*") return true;
    if (acceptedFileType === normalizedFileType) return true;

    if (acceptedFileType.endsWith("/*")) {
      return normalizedFileType.startsWith(acceptedFileType.slice(0, -1));
    }

    return false;
  });
};
